import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock(_Transition, {
    name: "cfmoto-share-slide"
  }, {
    default: _withCtx(() => [$props.modelValue ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(["cfmoto-share", [$props.type]]),
      onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => $options.close && $options.close(...args), ["stop"]))
    }, null, 2)) : _createCommentVNode("", true)]),
    _: 1
  });
}